import React from "react";
import "./TermAndCondition.css";
import { Helmet } from "react-helmet";

export default function TermAndCondition() {
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className="terms-container">
        <div className="terms-content">
          <h1 className="terms-title">Terms and Conditions for SART WITH K</h1>

          <section className="terms-section">
            <p>By downloading, installing, or using the SART WITH K mobile application, you agree to be bound by these Terms and Conditions. These Terms govern your access to and use of the App, including any content, functionality, and services provided through the App.</p>
          </section>

          <section className="terms-section">
            <h2>Age Restrictions</h2>
            <p>The App is intended for users aged 13 and above. By using the App, you confirm that you are at least 13 years old or have received parental or guardian consent to use the App. We do not knowingly permit children under the age of 13 to use the App or submit personal information without appropriate consent.</p>
          </section>

          <section className="terms-section">
            <h2>Acceptable Use</h2>
            <p>You agree to use the App for lawful purposes only and not to misuse or interfere with its operation. This includes refraining from uploading harmful content, attempting unauthorized access, or engaging in activities that may harm the App, its users, or its providers. Any violation of these Terms may result in the suspension or termination of your access to the App.</p>
          </section>

          <section className="terms-section">
            <h2>Intellectual Property</h2>
            <p>All content provided in the App, including product information, images, logos, and trademarks, is the property of SART WITH K or its partners and is protected by copyright and intellectual property laws. You may not copy, reproduce, or use any part of the App's content for commercial purposes without written permission.</p>
          </section>

          <section className="terms-section">
            <h2>Orders and Payment</h2>
            <p>When placing an order through the App, you agree to provide accurate and complete information. Currently, all payments must be made via KHQR using ABA. We reserve the right to refuse or cancel any order if we suspect fraud, unauthorized activity, or illegal use.</p>
          </section>

          <section className="terms-section">
            <h2>Delivery</h2>
            <p>Orders will be delivered to the address provided during checkout. We currently offer delivery within Phnom Penh and selected provinces. Delivery typically takes 1–2 days or longer, depending on the location and availability.</p>
            <p>
              <strong>Note:</strong> Orders confirmed before 10:00 AM may be eligible for same-day delivery, especially within Phnom Penh.
            </p>
          </section>

          <section className="terms-section">
            <h2>Product Availability and Pricing</h2>
            <p>Purchases made through the App are subject to product availability, pricing, and shipping terms as presented at the time of order. We reserve the right to cancel or refuse any order at our discretion, including in cases of pricing errors or suspected fraud.</p>
          </section>

          <section className="terms-section">
            <h2>Refunds and Returns</h2>
            <p>
              Refunds and returns are handled according to our refund policy. Refunds and exchanges are accepted within 3 days of purchase, provided the item is unused, in its original packaging, and accompanied by a valid receipt. After this period, we cannot offer a refund or exchange. For full details or to initiate a return, please contact our customer support team via email at
              <a href="mailto:sartwithk@gmail.com"> sartwithk@gmail.com</a>.
            </p>
          </section>

          <section className="terms-section">
            <h2>Third-Party Services</h2>
            <p>The App may contain links to third-party services or platforms, such as payment processors or shipping providers. We are not responsible for the content, terms, or privacy practices of these third parties. We recommend reviewing their policies before using their services through our App.</p>
          </section>

          <section className="terms-section">
            <h2>Disclaimer</h2>
            <p>We strive to provide accurate and up-to-date information, but we do not guarantee that the App will be error-free or uninterrupted. We reserve the right to modify, suspend, or discontinue any aspect of the App at any time without prior notice.</p>
          </section>

          <section className="terms-section">
            <h2>Changes to Terms</h2>
            <p>We reserve the right to change or update these Terms and Conditions at any time without providing advance notice to users. Continued use of the App after changes are posted constitutes your acceptance of those changes.</p>
          </section>

          <section className="terms-section">
            <h2>Privacy Policy</h2>
            <p>Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, and share your personal information. By agreeing to these Terms, you also acknowledge that you have read and understood our Privacy Policy.</p>
          </section>

          <section className="terms-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions or concerns about these Terms and Conditions, please contact us at
              <a href="mailto:sartwithk@gmail.com"> sartwithk@gmail.com</a>.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
